import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden/Hidden';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { ArticleSkeleton } from 'common/ui/skeleton-ui';
import DetailsGridItem from 'modules2/components/DetailsGridItem';
import { ShowMore } from 'modules2/components';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import container from './GenreStationCard.container';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 345,
    // marginBottom: theme.spacing(1),
    background: theme.palette.paperColor,
    color: theme.palette.textColor,
  },
  articleContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    marginTop: 10,
  },
  nextBtn: {
    color: '#ffffff',
    width: 300,
    fontWeight: 400,
    fontFamily: 'Arial',
    textTransform: 'uppercase',
    paddingTop: 10,
    marginBottom: 10,
    backgroundColor: theme.palette.buttonBackground,
    '&:hover': {
      backgroundColor: theme.palette.nextBtnHover,
    },
  },
  empty: {
    fontFamily: theme.typography.fontFamily,
    paddingBottom: theme.spacing(1),
  },
}));

const GenreStationCard = (props) => {
  const classes = useStyles();
  const {
    radioState,
    userHistoryRadioState: { heartedStationIds },
    onViewRadioPlayerStart,
    onFavouriteRadioStation,
    onDeleteFavoriteRadioStation,
    onShowSnackbarNotification,
  } = props;
  const { genresLoading, radios, genreStations } = radioState;
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.up('xs'));
  const [moreValue, setMoreValue] = useState(matchesSM ? 10 : 9);
  const nextRadioList = () => {
    setMoreValue(moreValue + 6);
  };
  useEffect(() => {
    setMoreValue(9);
  }, [radioState]);

  const onClickHandler = (id) => {
    onViewRadioPlayerStart(id);
  };

  const onFavouriteClick = (id) => {
    if (
        heartedStationIds.some((stationId) => stationId === id)
    ) {
      onShowSnackbarNotification(`Radio deleted from favorite 😢`);
      onDeleteFavoriteRadioStation(id);
    } else {
      onShowSnackbarNotification(`Radio Hearted ❤️`);
      onFavouriteRadioStation(id);
    }
  };

  const displayArticleList = (loading, num) => {
    if (loading) {
      return [...Array(num)].map((_, idx) => {
        return <ArticleSkeleton key={idx} />;
      });
    }

    return (
      genreStations.length === 0 ?
        (
          <div className={classes.empty}>
            Radio not available.
          </div>
        ) :
        (
          genreStations.slice(0, moreValue).map((radio, index) => {
            return (
              <DetailsGridItem
                key={radio.stationuuid}
                stationid={radio.stationuuid}
                image={radio.favicon}
                title={radio.name}
                subtitle={radio.tags}
                url={radio.url_resolved}
                radio_id={radio.stationuuid}
                radio={radio}
                onClick={onClickHandler}
                onFavouriteClick={onFavouriteClick}
              />
            );
          })
        )
    );
  };

  return (
    <Card className={classes.root}>
      <CardContent style={{ padding: 0 }}>
        <Hidden xsDown>
          <div className={classes.articleContainer}>
            {displayArticleList(genresLoading, 3)}
          </div>
        </Hidden>
        <Hidden smUp>
          <div className={classes.articleContainer}>
            {displayArticleList(genresLoading, 1)}
          </div>
        </Hidden>
        {genreStations.length > moreValue && !genresLoading && (
            <ShowMore nextRadioList={nextRadioList}/>
        )}
      </CardContent>
    </Card>
  );
};

export default container(GenreStationCard);
